import React, { useEffect } from "react";

import { GTM_EVENTS } from "../../constants";
import Tracking from "../../services/tracking.service";
import FundraiserForm from "./fundraiserForm";

export function CreateFundraiser() {

    useEffect(() => {
        Tracking.trackGTM({event: GTM_EVENTS.FUNDRAISER_CREATION_INITIATED});
    }, [])

    return <FundraiserForm />
}